// Helpers
import _ from 'lodash';
import 'moment/locale/lt';

// Language resources
import adminLanguageResource from './resources/admin.json';
import cdnLanguageResource from './resources/cdn.json';
import commonLanguageResource from './resources/common.json';
import labelsLanguageResource from './resources/labels.json';
import webLanguageResource from './resources/web.json';
import workerLanguageResource from './resources/worker.json';

// Types
export type $Translate = {
  t: (arg0: string) => string;
};

type $LanguageResourceTypeEnums = {
  admin: 'ADMIN';
  cdn: 'CDN';
  web: 'WEB';
  worker: 'WORKER';
};
export type $LanguageResourceType = $LanguageResourceTypeEnums[keyof $LanguageResourceTypeEnums];

export const languageResourceType: $LanguageResourceTypeEnums = {
  admin: 'ADMIN',
  cdn: 'CDN',
  web: 'WEB',
  worker: 'WORKER',
};

type $LanguageEnums = {
  en: 'en';
};
export type $Language = $LanguageEnums[keyof $LanguageEnums];

export const language: $LanguageEnums = {
  en: 'en',
};

type $LanguageResource = Record<$Language, { translation: Record<string, string> }>;

const languageResources: Record<$LanguageResourceType, () => $LanguageResource> = {
  [languageResourceType.admin]: () => _.merge(
    commonLanguageResource,
    labelsLanguageResource,
    adminLanguageResource,
  ),
  [languageResourceType.cdn]: () => _.merge(
    commonLanguageResource,
    labelsLanguageResource,
    cdnLanguageResource,
  ),
  [languageResourceType.web]: () => _.merge(
    commonLanguageResource,
    labelsLanguageResource,
    webLanguageResource,
  ),
  [languageResourceType.worker]: () => _.merge(
    commonLanguageResource,
    labelsLanguageResource,
    workerLanguageResource,
  ),
};

export const getLanguageResource = (
  type: $LanguageResourceType,
): $LanguageResource => languageResources[type]();

export * from './labels';

export {
  default as i18next,
} from 'i18next';
